import { baseUrl } from "config/apiUrl";
import SuperFetch from "config/SuperFetch";

const Blog = {
	getLatestJobList: (page = 1, limit = 6, lan = "EN") => {
		return SuperFetch(
			`${baseUrl.social}/articles/?&page=${page}&limit=${limit}&context=Article&categories=Corporate&language=EN`
		);
	},
	getBlogList: (page = 1, limit = 9, lan = "EN") => {
		return SuperFetch(
			`${baseUrl.social}/articles/?&page=${page}&limit=${limit}&context=Article&categories=Corporate&language=EN`
		);
	},
	singleJobPost: (id) => {
		return SuperFetch(`${baseUrl.social}/articles/${id}`);
	},
	singleBlog: (id) => {
		return SuperFetch(`${baseUrl.social}/articles/${id}`);
	},
};

export default Blog;
